module.exports = __webpack_public_path__ + "img/ag3.2950762d.png";